import DynamicClass from './utils/dynamicClass.ts';
import DynamicRenderBlock from './utils/dynamicRenderBlock.ts';

class Main {
	constructor() {
		this.init();
	}

	getSectionCallFunction(): NodeListOf< HTMLElement > {
		return Array.prototype.slice.call( document.querySelectorAll( '[data-call]' ) );
	}

	callFunctionDynamic( THIS: Main ) {
		const selector: NodeListOf< HTMLElement > = THIS.getSectionCallFunction();
		if ( selector.length > 0 ) {
			selector.forEach( item => {
				let functionNameString = item.getAttribute( 'data-call' );
				let callBackString = item.getAttribute( 'data-callback' );
				if ( functionNameString ) {
					let functionName = functionNameString.split( ';' );
					let callBack = callBackString ? callBackString.split( ';' ) : '';
					functionName.forEach( functionNameItem => {
						new DynamicClass( {
							className: functionNameItem,
							item: item,
							callback: callBack,
						} );
					} );
				}
			} );
		}
	}

	init() {
		const THIS = this;
		new DynamicRenderBlock();
		this.callFunctionDynamic( THIS );
	}
}
export default Main;
